import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'discussions.page.title': {
    id: 'discussions.page.title',
    defaultMessage: 'Discussions | {siteName}',
    description: 'Title tag',
  },
});

export default messages;
